import type { AdTagGroup } from "@services/engagements/commands/cmdGetEngagementAdTags"

/*
    Which tag groups the schedule and monitor pages show inline (MPN-1506). The ad detail
    panel shows every group; these two views are dense lists, so the ticket names the two
    that help pick an ad at a glance.

    Matched on the group's name because that is all a tag group has — there is no stable
    code. A rename in the Content Catalog therefore stops the chips appearing rather than
    breaking the page, which is why the callers treat "no groups" as a normal empty state.
    If these need to be Ops-configurable, that is a flag on TagGroup, not a longer list.
*/
export const INLINE_TAG_GROUPS = ["Target Action", "Customization Level"] as const

const WANTED = new Set<string>(INLINE_TAG_GROUPS.map((n) => n.toLowerCase()))

/** The subset of an ad's groups shown inline, in the order INLINE_TAG_GROUPS names them. */
export function inlineGroups(groups: AdTagGroup[] | undefined): AdTagGroup[] {
  if (!groups?.length) return []
  return groups
    .filter((g) => WANTED.has(g.name?.trim().toLowerCase() ?? ""))
    .sort((a, b) => order(a) - order(b))
}

function order(group: AdTagGroup): number {
  const i = INLINE_TAG_GROUPS.findIndex(
    (n) => n.toLowerCase() === group.name?.trim().toLowerCase(),
  )
  return i === -1 ? INLINE_TAG_GROUPS.length : i
}
